import {
  call,
  put,
} from 'redux-saga/effects';
import {
  axiosAuthInstance,
  API_END_POINTS,
  axiosEmptyInstance,
} from 'api';
import { MESSAGES, LYNX_CONNECT as LYNX_CONNECT_CONST } from 'appconstants';

import {
  LYNX_CONNECT,
  NOTIFICATION,
  LOADING,
} from '../actionTypes';

// Invoice APIs
const getInvoices = async (params) => (
  axiosAuthInstance.get(
    // eslint-disable-next-line
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/?${params['status.EQ']}page=${params.pageNum}&sortby=${params.sortBy}&direction=${params.direction}&size=${params.size}`,
  )
);

const getSingleInvoice = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}`,
  )
);

const getPdfDownloadLink = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/download`,
  )
);

const getPdfFileData = async (params) => (
  axiosEmptyInstance.get(
    params.url, {
      responseType: 'arraybuffer',
    },
  )
);

const postInvoice = async (params) => (
  axiosAuthInstance.post(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}`,
    params,
  )
);

const getInvoiceBucketPreSingedURL = async () => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_STORAGE}`,
  )
);

const putInvoiceFile = async (params) => (
  axiosEmptyInstance.put(
    `${params.api}`,
    params.file,
    { headers: { 'Content-Type': 'application/pdf' } },
  )
);

const postInvoiceFileUrl = async (params) => (
  axiosAuthInstance.post(
    `${API_END_POINTS.LYNX_CONNECT_STORAGE}`,
    params,
  )
);

// Location APIs
const getLocations = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_LOCATION}?page=${params.page}&size=${params.size}&sortby=${params.sortBy}&direction=${params.direction}`,
  )
);

const postLocation = async (params) => (
  axiosAuthInstance.post(
    `${API_END_POINTS.LYNX_CONNECT_LOCATION}`,
    params,
  )
);

// vendor

const getAllLynxConnectVendor = async () => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_VENDOR}?page=1&size=10000&sortby=createdAt`,
  )
);

// Validate Line Items APIs

const getValidateLineItems = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.gid}/line-items?status=NO_MATCH`,
  )
);

// Existing Line Items APIs

const getExistLineitems = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.gid}/line-items?status=MATCH`,
  )
);

const patchPos = async (params) => (
  axiosAuthInstance.patch(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/processed`,
  )
);

const getLineItemHistory = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/barcode/${params.barcode}`,
  )
);

// common between Validate Line Items and Existing Line Items

const getLineItemOnGid = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/line-items/${params.lineItemGid}`,
  )
);

const putLineItemOnGid = async (params) => (
  axiosAuthInstance.put(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/line-items/${params.lineItemGid}`,
    params.data,
  )
);

const putLineItems = async (params) => (
  axiosAuthInstance.put(
    `${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/line-items`,
    params.payload,
  )
);

// audit log

const getAuditLogTimeline = async (params) => (
  axiosAuthInstance.get(`${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/audit-history`)
);

const requestApprovalApi = async (params) => (
  axiosAuthInstance.patch(`${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/requestApproval`)
);

const postAuditEvent = async (params) => (
  axiosAuthInstance.post(`${API_END_POINTS.LYNX_CONNECT_INVOICE}/${params.invoiceGid}/audit`, params.payload)
);


export function* fetchInvoice(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    let status = '';
    switch (action.payload.filterByStatus) {
      case 'ALL':
        status = '';
        break;
      case LYNX_CONNECT_CONST.INVOICE_STATUS.READY_TO_PROCESS:
        status = `status.EQ=${LYNX_CONNECT_CONST.INVOICE_STATUS.READY_TO_PROCESS}&`;
        break;
      case 'ANALYZING':
        status = `status.EQ=${LYNX_CONNECT_CONST.INVOICE_STATUS.ANALYSING}&`;
        break;
      case LYNX_CONNECT_CONST.INVOICE_STATUS.PROCESSED:
        status = `status.EQ=${LYNX_CONNECT_CONST.INVOICE_STATUS.PROCESSED}&`;
        break;
      case LYNX_CONNECT_CONST.INVOICE_STATUS.WAITING_FOR_APPROVAL:
        status = `status.EQ=${LYNX_CONNECT_CONST.INVOICE_STATUS.WAITING_FOR_APPROVAL}&`;
        break;
      default:
        status = '';
    }
    const params = {
      'status.EQ': status,
      sortBy: action.payload.sortBy && action.payload.sortBy !== '' ? action.payload.sortBy : 'createdAt',
      size: 10,
      pageNum: action.payload.pageNum && action.payload.pageNum !== '' ? action.payload.pageNum : '1',
      direction: action.payload.direction && action.payload.direction !== '' ? action.payload.direction : 'DESC',
    };
    const { data } = yield call(getInvoices, params);
    const lynxConnectInvoicesData = data.entity.content.map((item) => {
      let formattedStatus = LYNX_CONNECT_CONST.INVOICE_STATUS_FORMATTED.ANALYSING;
      switch (item.status) {
        case LYNX_CONNECT_CONST.INVOICE_STATUS.READY_TO_PROCESS:
          formattedStatus = LYNX_CONNECT_CONST.INVOICE_STATUS_FORMATTED.READY_TO_PROCESS;
          break;
        case LYNX_CONNECT_CONST.INVOICE_STATUS.ANALYSING:
          formattedStatus = LYNX_CONNECT_CONST.INVOICE_STATUS_FORMATTED.ANALYSING;
          break;
        case LYNX_CONNECT_CONST.INVOICE_STATUS.PROCESSED:
          formattedStatus = LYNX_CONNECT_CONST.INVOICE_STATUS_FORMATTED.PROCESSED;
          break;
        case LYNX_CONNECT_CONST.INVOICE_STATUS.WAITING_FOR_APPROVAL:
          formattedStatus = LYNX_CONNECT_CONST.INVOICE_STATUS_FORMATTED.WAITING_FOR_APPROVAL;
          break;
        default:
          formattedStatus = LYNX_CONNECT_CONST.INVOICE_STATUS_FORMATTED.ANALYSING;
      }

      return {
        gid: item.gid,
        id: item.gid,
        location: item.lynxConnectLocation.name,
        fileName: item.fileName,
        scanDate: item.scanDate,
        status: formattedStatus,
      };
    });
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_CONTENT,
      payload: lynxConnectInvoicesData,
    });
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_TOTAL_ELEMENTS,
      payload: data.entity.totalElements,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    // in case of failure show no value
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_CONTENT,
      payload: [],
    });
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_TOTAL_ELEMENTS,
      payload: 0,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* fetchInvoiceMeta(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const params = {
      page: action?.payload?.pageNum ?? 1,
      size: action?.payload?.size ?? 1000,
      sortBy: action?.payload?.sortBy ?? 'createdAt',
      direction: action?.payload?.direction ?? 'DESC',
    };
    const { data } = yield call(getLocations, params);
    const locationOptions = data.entity.content.map((item) => ({
      label: item.name,
      value: item.gid,
    }));
    const lynxConnectVendorResponse = yield call(getAllLynxConnectVendor);
    const vendorOptions = lynxConnectVendorResponse?.data?.entity?.content
    ?.map((vendor) => ({
      label: vendor.name,
      value: vendor.gid,
    }));
    const metaData = {
      vendors: vendorOptions ?? [],
      locations: locationOptions,
    };
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_META,
      payload: metaData,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    const metaData = {
      vendors: [],
      locations: [],
    };
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_META,
      payload: metaData,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* addNewInvoice(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    // get presigned url to access the S3 bucket
    const preSignedUrlData = yield call(getInvoiceBucketPreSingedURL);
    const presignedUrl = preSignedUrlData.data.entity;
    // put the file using the presigned URL into the S3 bucket
    const fileUploadParams = {
      api: presignedUrl,
      file: action.payload.fileData,
    };
    const s3FileUrl = yield call(putInvoiceFile, fileUploadParams);
    const fileAccessUrlObj = new URL(s3FileUrl.config.url);
    const fileAccessUrl = `${fileAccessUrlObj.origin}${fileAccessUrlObj.pathname}`;
    // post the file URL to find it in the S3 bucket
    const fileUrlParams = {
      fileUrl: fileAccessUrl,
      keyType: 'LYNX_CONNECT_INVOICE',
    };
    const addNewInvoiceFileUrl = yield call(postInvoiceFileUrl, fileUrlParams);
    // post other invoice details
    const invoiceDetailsParams = {
      lynxConnectVendorGid: action.payload?.lynxConnectVendorGid,
      fileName: action.payload?.fileName,
      fileUrl: addNewInvoiceFileUrl.data?.entity?.fileUrl,
      lynxConnectLocationGid: action.payload?.selectedLocationGid,
    };
    yield call(postInvoice, invoiceDetailsParams);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Successfully added the Invoice',
    });
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_NEW_STATUS,
      payload: 'Success',
    });
    // re-fetch invoices
    yield put({
      type: LYNX_CONNECT.FETCH_INVOICE,
      payload: {},
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_NEW_STATUS,
      payload: 'Error',
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* fetchLocations(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const { data } = yield call(getLocations, {
      sortBy: action.payload?.sortBy && action.payload?.sortBy !== '' ? action.payload.sortBy : 'createdAt',
      size: 10,
      page: action.payload?.pageNum && action.payload?.pageNum !== '' ? action.payload.pageNum : '1',
      direction: action.payload?.direction && action.payload?.direction !== '' ? action.payload.direction : 'DESC',
    });
    const lynxConnectLocationsData = data.entity.content.map((item) => ({
      gid: item.gid,
      name: item.name,
      lynxLocationId: item.lynxLocationId,
    }));
    yield put({
      type: LYNX_CONNECT.SET_LOCATION_CONTENT,
      payload: lynxConnectLocationsData,
    });
    yield put({
      type: LYNX_CONNECT.SET_LOCATION_TOTAL_ELEMENTS,
      payload: data.entity.totalElements,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_LOCATION_CONTENT,
      payload: [],
    });
    yield put({
      type: LYNX_CONNECT.SET_LOCATION_TOTAL_ELEMENTS,
      payload: 0,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* addNewLocation(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const response = yield call(postLocation, {
      name: action.payload.name,
      lynxLocationId: action.payload.lynxLocationId,
    });
    if (!response.data.status?.startsWith('SUCCESS')) {
      throw new Error(response.data?.message || 'Could not add new Location.');
    }
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Successfully added a new location',
    });
    yield put({
      type: LYNX_CONNECT.FETCH_LOCATIONS,
      payload: {
        pageNum: 1,
        sortBy: 'createdAt',
        direction: 'DESC',
      },
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* fetchValidate(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const { data } = yield call(getValidateLineItems, {
      gid: action.payload.gid,
    });
    const tableDataValues = data.entity.content.map((item) => ({
      gid: item.id,
      itemName: item.name,
      barcode: item.barcode,
      sku: item.sku,
      vendorItemCode: item.itemCode,
      quantity: item.quantity,
      unit: item.unit,
      caseCost: item.caseCost,
      caseQuantity: item.caseQuantity,
      caseItemQuantity: item.itemQuantityPerCase,
      totalCaseItemQuantity: item.totalItemQuantity,
      unitCost: item.price,
      totalCost: item.totalCost,
      description: item.description,
      handWritten: item.handWritten,
    }));
    yield put({
      type: LYNX_CONNECT.SET_VALIDATE_CONTENT,
      payload: tableDataValues,
    });
    yield put({
      type: LYNX_CONNECT.SET_VALIDATE_TOTAL_ELEMENTS,
      payload: data.entity.content.length,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_VALIDATE_CONTENT,
      payload: [],
    });
    yield put({
      type: LYNX_CONNECT.SET_VALIDATE_TOTAL_ELEMENTS,
      payload: 0,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* validateUpdateAll(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const { data: { entity } } = yield call(putLineItems, {
      invoiceGid: action.payload.gid,
      payload: action.payload.payload,
    });
    if (entity.totalProcessed === entity.successful) {
      yield put({
        type: NOTIFICATION.SUCCESS,
        payload: 'Successfully updated all the Line Items.',
      });
    } else {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: 'Some Line Items update Failed.',
      });
    }
    yield put({
      type: LYNX_CONNECT.FETCH_VALIDATE,
      payload: { gid: action.payload.gid },
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* validateEditRowSync(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const response = yield call(putLineItemOnGid, {
      invoiceGid: action.payload.invoiceGid,
      lineItemGid: action.payload.lineItemGid,
      data: action.payload.payload,
    });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Successfully Updated the Selected Item',
    });
    yield put({
      type: LYNX_CONNECT.SET_VALIDATE_EDIT_ROW_SYNC_STATUS,
      payload: {
        status: 'Success',
        lineItemId: action.payload.lineItemGid,
        syncStatus: response.data?.data?.status ?? response.data?.entity?.status,
      },
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_VALIDATE_EDIT_ROW_SYNC_STATUS,
      payload: {
        status: 'Error',
        lineItemId: null,
      },
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

// This API is not currently in use.
// eslint-disable-next-line
export function* validateRowSync(action) {
  // call api
  yield put({
    type: NOTIFICATION.SUCCESS,
    payload: 'Successfully moved to existing line items.',
  });
}

export function* fetchExist(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const { data } = yield call(getExistLineitems, {
      gid: action.payload.gid,
    });
    const tableDataValues = data.entity.content.map((item) => ({
      gid: item.id,
      itemName: item.name,
      barcode: item.barcode,
      sku: item.sku,
      vendorItemCode: item.itemCode,
      quantity: item.quantity,
      unit: item.unit,
      caseCost: item.caseCost,
      caseQuantity: item.caseQuantity,
      caseItemQuantity: item.itemQuantityPerCase,
      totalCaseItemQuantity: item.totalItemQuantity,
      unitCost: item.price,
      newSellingPrice: item.newSellingPrice,
      oldSellingPrice: item.oldSellingPrice,
      oldMargin: item.oldMargin,
      newMargin: item.newMargin,
      totalCost: item.totalCost,
      description: item.description,
      handWritten: item.handWritten,
      // previousCaseCost: 3210, // for marking caseCost and row highlight
    }));
    yield put({
      type: LYNX_CONNECT.SET_EXIST_CONTENT,
      payload: tableDataValues,
    });
    yield put({
      type: LYNX_CONNECT.SET_EXIST_CONTENT_TOTAL_ELEMENTS,
      payload: data.entity.content.length,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_EXIST_CONTENT,
      payload: [],
    });
    yield put({
      type: LYNX_CONNECT.SET_EXIST_CONTENT_TOTAL_ELEMENTS,
      payload: 0,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* fetchExistHistory(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const { data: { entity } } = yield call(getLineItemHistory, {
      invoiceGid: action.payload.invoiceGid,
      barcode: action.payload.barcode,
    });
    const lineItemHistory = {
      itemName: action.payload.itemName,
      barcode: action.payload.barcode,
      unitCost: action.payload.unitCost,
      history: entity.priceHistory.map((item) => ({
        // eslint-disable-next-line
        id: item._id,
        date: item.date,
        unit: item.unit,
        unitCost: item.price,
        quantity: item.quantity,
        newPrice: item.newSellingPrice,
        oldPrice: item.oldSellingPrice,
        location: item.lynx_location_id,
      })),
    };
    yield put({
      type: LYNX_CONNECT.SET_EXIST_HISTORY,
      payload: lineItemHistory,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_EXIST_HISTORY,
      payload: {
        itemName: '',
        barcode: '',
        unitCost: '',
        history: [],
      },
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* existUpdateAll(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const { data: { entity } } = yield call(putLineItems, {
      invoiceGid: action.payload.gid,
      payload: action.payload.payload,
    });
    if (entity.totalProcessed === entity.successful) {
      yield put({
        type: NOTIFICATION.SUCCESS,
        payload: 'Successfully updated all the Line Items.',
      });
    } else {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: 'Some Line Items update Failed.',
      });
    }
    yield put({
      type: LYNX_CONNECT.FETCH_EXIST,
      payload: { gid: action.payload.gid },
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

export function* existEditRowSync(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    yield call(putLineItemOnGid, {
      invoiceGid: action.payload.invoiceGid,
      lineItemGid: action.payload.lineItemGid,
      data: action.payload.payload,
    });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Successfully Updated the Line Item',
    });
    const singleLineItemResponse = yield call(getLineItemOnGid, {
      invoiceGid: action.payload.invoiceGid,
      lineItemGid: action.payload.lineItemGid,
    });
    const singleLineItemDetails = singleLineItemResponse.data?.entity?.content?.[0];
    if (singleLineItemDetails?.status === 'NO_MATCH') {
      yield put({
        type: LYNX_CONNECT.SET_EXIST_EDIT_ROW_SYNC_STATUS,
        payload: {
          status: 'Success',
          lineItemId: action.payload.lineItemGid,
          syncStatus: 'NO_MATCH',
        },
      });
    } else {
      // in the payload set the new selling price based on
      // first time or not.
      const singleLineItemPayload = {
        gid: singleLineItemDetails.id,
        itemName: singleLineItemDetails.name,
        barcode: singleLineItemDetails.barcode,
        sku: singleLineItemDetails.itemCode,
        vendorItemCode: singleLineItemDetails.itemCode,
        quantity: singleLineItemDetails.quantity,
        unit: singleLineItemDetails.unit,
        caseCost: singleLineItemDetails.caseCost,
        caseQuantity: singleLineItemDetails.caseQuantity,
        caseItemQuantity: singleLineItemDetails.itemQuantityPerCase,
        totalCaseItemQuantity: singleLineItemDetails.totalItemQuantity,
        unitCost: singleLineItemDetails.price,
        newSellingPrice: singleLineItemDetails.newSellingPrice,
        oldSellingPrice: singleLineItemDetails.oldSellingPrice,
        oldMargin: singleLineItemDetails.oldMargin,
        newMargin: singleLineItemDetails.newMargin,
        totalCost: singleLineItemDetails.totalCost,
        description: singleLineItemDetails.description,
        handWritten: singleLineItemDetails.handWritten,
        // previousCaseCost: singleLineItemDetails.previousCaseCost ?? 3200, // check this set proper value
      };
      yield put({
        type: LYNX_CONNECT.SET_EXIST_SINGLE_LINE_ITEM_VALUE,
        payload: singleLineItemPayload,
      });
      yield put({
        type: LYNX_CONNECT.SET_EXIST_EDIT_ROW_SYNC_STATUS,
        payload: {
          status: 'Success',
          lineItemId: action.payload.lineItemGid,
          syncStatus: 'MATCH',
        },
      });
    }
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    yield put({
      type: LYNX_CONNECT.SET_EXIST_EDIT_ROW_SYNC_STATUS,
      payload: 'Error',
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
  }
}

// This API is not currently in use.
// eslint-disable-next-line
export function* existRowSync(action) {
  // call api
  yield put({
    type: NOTIFICATION.SUCCESS,
    payload: 'Successfully Upated the Line Item',
  });
}

export function* existUpdatePos(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    const response = yield call(patchPos, {
      invoiceGid: action.payload.invoiceGid,
    });
    if (!response.data.status?.startsWith('SUCCESS')) {
      throw new Error(response.data?.message || 'Update POS failed.');
    }
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Successfully Updated POS',
    });
    if (action.payload.existLineItemPage) {
      yield put({
        type: LYNX_CONNECT.EXIST_UPDATE_POS_STATUS,
        payload: 'Success',
      });
    }
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    if (action.payload.existLineItemPage) {
      yield put({
        type: LYNX_CONNECT.EXIST_UPDATE_POS_STATUS,
        payload: 'Error',
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
    if (!action.payload.existLineItemPage) {
      yield put({
        type: LYNX_CONNECT.FETCH_AUDIT_LOG,
        payload: {
          gid: action.payload.invoiceGid,
        },
      });
      yield put({
        type: LYNX_CONNECT.FETCH_INVOICE_DETAIL,
        payload: {
          gid: action.payload.invoiceGid,
        },
      });
    }
  }
}

// common functionality shared between
// validate line items and review existing line items
// pages

export function* fetchInvoiceDetail(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_SUB_LOADING,
      payload: {
        name: LYNX_CONNECT_CONST.SUB_LOADING.INVOICE_DETAIL,
        loading: true,
      },
    });
    // get the invoice detail data
    const singleInvoiceDetailResponse = yield call(getSingleInvoice, {
      invoiceGid: action.payload.gid,
    });
    const invoiceDetailData = singleInvoiceDetailResponse?.data?.entity;
    const invoiceDetail = {
      vendorName: invoiceDetailData?.vendorName ?? '',
      invoiceNumber: invoiceDetailData?.invoiceNumber ?? '',
      totalAmount: invoiceDetailData?.totalAmount ?? 0,
      billedTo: invoiceDetailData?.billedTo ?? '',
      invoiceDate: invoiceDetailData?.invoiceDate ?? '',
      subTotalAmount: invoiceDetailData?.subTotalAmount ?? '',
      fileName: invoiceDetailData?.fileName ?? '',
      scanDate: invoiceDetailData?.scanDate ?? '',
      status: invoiceDetailData?.status ?? '',
      location: invoiceDetailData?.lynxConnectLocation?.name ?? '',
    };
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_DETAIL,
      payload: invoiceDetail,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    const invoiceDetail = {
      vendorName: '',
      invoiceNumber: '',
      totalAmount: 0,
      billedTo: '',
      invoiceDate: '',
      subTotalAmount: '',
      fileName: '',
      scanDate: '',
      status: '',
      location: '',
    };
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_DETAIL,
      payload: invoiceDetail,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_SUB_LOADING,
      payload: {
        name: LYNX_CONNECT_CONST.SUB_LOADING.INVOICE_DETAIL,
        loading: false,
      },
    });
  }
}

export function* fetchInvoicePdf(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_SUB_LOADING,
      payload: {
        name: LYNX_CONNECT_CONST.SUB_LOADING.PDF_DATA,
        loading: true,
      },
    });
    // get the invoice pdf file
    const getFileUrlResponse = yield call(getPdfDownloadLink, {
      invoiceGid: action.payload.gid,
    });
    let filePdfDataResponse = null;
    if (getFileUrlResponse?.data?.entity?.fileUrl
      && getFileUrlResponse?.data?.entity?.fileUrl !== '') {
      filePdfDataResponse = yield call(getPdfFileData, {
        url: getFileUrlResponse?.data?.entity?.fileUrl,
      });
    }
    const invoicePdf = filePdfDataResponse?.data ?? new ArrayBuffer('');
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_PDF,
      payload: invoicePdf,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
    });
    const invoicePdf = new ArrayBuffer('');
    yield put({
      type: LYNX_CONNECT.SET_INVOICE_PDF,
      payload: invoicePdf,
    });
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({
      type: LYNX_CONNECT.SET_SUB_LOADING,
      payload: {
        name: LYNX_CONNECT_CONST.SUB_LOADING.PDF_DATA,
        loading: false,
      },
    });
  }
}

// Audit log

export function* fetchAuditLog(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_SUB_LOADING,
      payload: {
        name: LYNX_CONNECT_CONST.SUB_LOADING.AUDIT_TIMELINE,
        loading: true,
      },
    });
    // call API to fetch the audit log timeline
    const response = yield call(getAuditLogTimeline, {
      invoiceGid: action.payload.gid,
    });
    if (response?.data?.status !== 'SUCCESS') {
      throw new Error(response?.data?.message);
    }
    const auditLogTimeline = response?.data?.entity;
    yield put({
      type: LYNX_CONNECT.SET_AUDIT_LOG,
      payload: auditLogTimeline,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e?.response?.data?.message ?? MESSAGES.API_ERROR,
    });
  } finally {
    yield put({
      type: LYNX_CONNECT.SET_SUB_LOADING,
      payload: {
        name: LYNX_CONNECT_CONST.SUB_LOADING.AUDIT_TIMELINE,
        loading: false,
      },
    });
  }
}

export function* requestApproval(action) {
  try {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: true,
    });
    // call API to set rqeuest for approval
    const response = yield call(requestApprovalApi, {
      invoiceGid: action.payload.gid,
    });
    if (response?.data?.status !== 'SUCCESS') {
      throw new Error(response?.data?.message);
    }
    yield put({
      type: NOTIFICATION.SUCCESS,
    });
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e?.response?.data?.message ?? MESSAGES.API_ERROR,
    });
  } finally {
    yield put({
      type: LYNX_CONNECT.SET_MAIN_LOADING,
      payload: false,
    });
    if (!action.payload.existLineItemPage) {
      yield put({
        type: LYNX_CONNECT.FETCH_AUDIT_LOG,
        payload: {
          gid: action.payload.gid,
        },
      });
      yield put({
        type: LYNX_CONNECT.FETCH_INVOICE_DETAIL,
        payload: {
          gid: action.payload.gid,
        },
      });
    } else {
      yield put({
        type: LYNX_CONNECT.FETCH_INVOICE_DETAIL,
        payload: {
          gid: action.payload.gid,
        },
      });
    }
  }
}

export function* auditEvent(action) {
  try {
    // const response =
    yield call(postAuditEvent, {
      invoiceGid: action.payload.gid,
      payload: action.payload.payload,
    });
    // if (response?.data?.status !== 'SUCCCESS') {
    //   throw new Error(response?.data?.message);
    // }
  } catch (e) {
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e?.response?.data?.message ?? MESSAGES.API_ERROR,
    });
  }
}
